export default function EndPoint(namePrefix, apiPrefix) {
  return (name, endpoint) => {
    return {
      name: namePrefix + name,
      endpoint: `${apiPrefix}/${endpoint}`
    };
  };
}
